export default __webpack_public_path__ + "static/media/pyszne.9ed0f376.svg";